import { useState } from "react"
import { MutateButton } from "@imago/api-client-for-react"
import { useProfile, useSignOut } from '../api.ts'
import { ImagoCare } from './Care.tsx'
import { Hello } from './Hello.tsx'

export function AccountSettings() {
	const user = useProfile()!

	const [yourDetailsShown, setYourDetailsShown] = useState<boolean>(false)
	const [legalDetailsShown, setLegalDetailsShown] = useState<boolean>(false)

	const signOut = useSignOut()

	return <main>
		<Hello/>
		<section>
		<h1>Account settings</h1>
		<fieldset>
			<hgroup aria-controls="your-details" onClick={ev => {
				if (ev.defaultPrevented) return
				ev.preventDefault()
				setYourDetailsShown(!yourDetailsShown)
			}}>
				<h5>Your details</h5>
				<div role="toolbar">
					<button>
						<span className="material-symbols-outlined">{!yourDetailsShown ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</span>
					</button>
				</div>
			</hgroup>
			<div id="your-details" hidden={!yourDetailsShown}>
				<label>
					<span>Your chosen first name</span>
					<input type="text" value={user.shortName} readOnly/>
				</label>
				<label>
					<span>Your pronouns</span>
					<input type="text" value={user.pronouns} readOnly/>
				</label>
			</div>
		</fieldset>
		<fieldset>
			<hgroup aria-controls="legal-details" onClick={ev => {
				if (ev.defaultPrevented) return
				ev.preventDefault()
				setLegalDetailsShown(!legalDetailsShown)
			}}>
				<h5>Legal details</h5>
				<div role="toolbar">
					<button>
						<span className="material-symbols-outlined">{!legalDetailsShown ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</span>
					</button>
				</div>
			</hgroup>
			<div id="legal-details" hidden={!legalDetailsShown}>
				<label>
					<span>Your legal name</span>
					<input type="text" value={user.legalName} readOnly/>
				</label>
				<label>
					<span>Date of birth</span>
					<input type="date" value={user.dateOfBirth.toString()} readOnly/>
				</label>
			</div>
		</fieldset>
		<ImagoCare/>
		<MutateButton mutation={signOut}>Sign out</MutateButton>
		</section>
	</main>
}
